<template>
  <div class="card-modal__sidebar-links">
    <div class="card-modal__sidebar-links-wrapper">
      <template v-for="link in links">
        <div
          v-if="!link.hide"
          :key="link.text"
          class="card-modal__sidebar-link"
          :class="link.class"
        >
          <AppLink
            @click.native="!link.to && scroll($event)"
            :href="link.to"
            :id="link.id"
            :text="link.text"
            :external="!!link.to"
            :data-target="link.data_target"
          >
            <AppIcon :icon="link.icon" />
            <!-- if user has activiy ⤵ -->
            <AppCounterRounded v-if="link.counter" :count="link.counter" />
          </AppLink>
          <!-- close button -->
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// Utilities
import CardActivityControl from '../mixins/CardActivityControl'
import MobileBreakpointControl from 'Mixins/MobileBreakpointControl'
// Components
import AppIcon from 'Ui/AppIcon'
import AppLink from 'Ui/AppLink'
import AppCounterRounded from 'Ui/AppCounterRounded'

export default {
  name: 'CardModalSidebarLinks',

  components: {
    AppIcon,
    AppLink,
    AppCounterRounded,
  },

  mixins: [MobileBreakpointControl, CardActivityControl],

  methods: {
    closeCard() {
      this.$store.dispatch('modal/close')
    },

    scroll(event) {
      let targetId = event.target.getAttribute('data-target')
      if (!targetId) return
      let target = document.querySelector(`#${targetId}`)
      target.scrollIntoView({
        behavior: 'smooth',
      })
    },
  },

  computed: {
    links() {
      return [
        {
          id: 'card-description',
          text: this.$t('card_modal.sections.description'),
          data_target: 'card-description',
          icon: 'far fa-align-left',
          hide: !!this.isMobile,
        },

        {
          id: 'card-tasks',
          text: this.$t('card_modal.sections.tasks'),
          data_target: 'card-tasks',
          icon: 'far fa-check-double',
          hide: !!this.isMobile,
        },

        {
          id: 'card-activity',
          text: this.$t('card_modal.sections.activity'),
          data_target: 'card-activity',
          icon: 'far fa-comment-alt-lines',
          counter: this.userAlerts.length,
          hide: !!this.isMobile,
        },

        {
          text: this.$t('card_modal.ui.attachments'),
          to: this.currentCard.drive_folder,
          icon: 'fab fa-google-drive',
          class: 'border-top',
          // hide: !!this.isMobile,
        },

        // {
        //   text: this.$t('card_modal.ui.help_guide'),
        //   to: '#',
        //   icon: 'fal fa-book',
        //   class: 'border-top',
        // },
      ]
    },
  },
}
</script>

<style scoped>
.card-modal__sidebar-links {
  height: 100%;
}

.card-modal__sidebar-links-wrapper {
  display: flex;
  flex-flow: column;
  position: sticky;
  top: 70px;
}

.app-separator.sidebar {
  background: var(--c-secondary-500);
  margin: 12px 0;
  width: 100%;
}

.card-modal__sidebar-link.border-top {
  margin-top: 10px;
  padding-top: 10px;
}

.card-modal__sidebar-link.border-top:after {
  width: 100%;
}

.app-link {
  display: inline-flex;
  gap: 10px;
  width: 100%;
  font-weight: 700;
  padding: 10px;
  border-radius: 4px;
  text-decoration: none;
  user-select: none;
  pointer-events: all;
}

.app-link:hover {
  background-color: var(--c-secondary-300);
}

.app-link >>> * {
  pointer-events: none;
}

.app-icon {
  font-size: 18px;
  color: var(--c-secondary);
}

.app-icon,
.app-link >>> .app-link__text {
  pointer-events: none;
}

.app-button--icon {
  font-size: 16px;
  background-color: transparent;
}

/* Responsive ---------- */
@media (max-width: 680px) {
  .card-modal__sidebar-links-wrapper {
    position: static;
    align-items: flex-start;
    width: 100%;
  }

  .card-modal__sidebar-link {
    width: 100%;
  }

  .card-modal__sidebar-link.border-top {
    margin: 0;
    padding: 0;
  }

  .card-modal__sidebar-link.border-top:after {
    content: unset;
  }

  .card-modal__sidebar-link .app-link {
    color: var(--c-primary);
    border-radius: 0;
    padding: 10px;
    border-radius: 4px;
  }

  .card-modal__sidebar-link .app-link:hover {
    background-color: var(--rgba-white-400);
  }

  .card-modal__sidebar-link .app-icon {
    color: var(--c-secondary);
  }
}
</style>
